import { useQuery } from "@tanstack/react-query";
import { GET_USERS } from "api/dataProviderTypes";
import fetchApi from "api/fetchApi";
import { useSnackbar } from "hooks/useSnackbar";
import { ApiResponseData, EntityWithPagination } from "api/types";
import { IUser } from "models/Employee";
import { IReturnType } from "hooks/types";

export const useGetUsers = () => {
  const { showSnackbar } = useSnackbar();
  const {
    data: response,
    isLoading,
    isError,
    isFetching,
    isSuccess,
    refetch,
  }: IReturnType<ApiResponseData<EntityWithPagination<IUser[]>>> = useQuery(
    [GET_USERS],
    () => fetchApi(`users`).get(""),
    {
      onSuccess: (data) => {
        showSnackbar("Employees Fetched Successfully", "success");
      },
      onError: (error) => {
        showSnackbar("Failed to Retrieve Employees", "error");
      },
    }
  );

  const users = response?.data?.data || [];
  const paginationData = response?.data || {};

  return { users, paginationData, isLoading, isError, isFetching, isSuccess, refetch };
};
